import { useLocation, useNavigate } from "react-router-dom";

export const NAV_LINKS = [
  { label: "Platform", section: "platform" },
  { label: "How It Works", section: "how-it-works" },
  { label: "For Companies", section: "for-companies" },
  { label: "About", path: "/about" },
  { label: "Contact", path: "/contact" },
];

// Returns a click handler that routes to a page or scrolls to a landing section
export const useNavLinks = () => {
  const navigate = useNavigate();
  const location = useLocation();

  return (link) => {
    if (link.path) {
      navigate(link.path);
      return;
    }
    const element = document.getElementById(link.section);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    } else if (location.pathname !== "/") {
      // Section lives on the landing page; Landing scrolls to it from the hash
      navigate(`/#${link.section}`);
    }
  };
};
